import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const RelatorioJobDownloadButton = ({ job, downloadingId, onDownload }) => {
  const busy = Boolean(job && downloadingId && job.id === downloadingId);
  return (
    <Button
      size="small"
      variant="contained"
      disabled={busy}
      onClick={() => onDownload(job)}
      startIcon={busy ? <CircularProgress size={14} color="inherit" /> : undefined}
      sx={{ minWidth: 108, flexShrink: 0 }}
    >
      {busy ? 'Baixando...' : 'Baixar'}
    </Button>
  );
};

RelatorioJobDownloadButton.propTypes = {
  job: PropTypes.object.isRequired,
  downloadingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onDownload: PropTypes.func.isRequired,
};

RelatorioJobDownloadButton.defaultProps = {
  downloadingId: null,
};

export default RelatorioJobDownloadButton;
